
import RcDomainMap from "../../common/RcDomainMap.js";
import InspectionUtils from "../inspection/InspectionUtils.js";
import Signature from "./Signature.js";

export default class SignatureMap extends RcDomainMap {
  static MODEL_NAME = "UserSignatureMap";
  
  constructor(domain, data) {
    super(domain, data, SignatureMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new SignatureMap(this.domain, data);
  }
  
  sortByName() {
    var list = this.list();
    return list.sort(InspectionUtils.SortByCreatedDate);
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getSignature(key);
      values.push(item);
    }
    return values;
  }

  find() {
    var keys = this.keys();
    var found = new SignatureMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.signatures().findById(key);
      var item = new Signature(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  getSignature(key) {
    var value = super.get(key);
    return new Signature(this.domain, value);
  }
}